import React from 'react';
import { motion } from 'framer-motion';
import { Link2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext'; // Assuming you have a LanguageContext

export const VerificationHeader = () => {
  const { translations } = useLanguage(); // Access translations from the context

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center justify-between"
    >
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary-50 rounded-lg">
          <Link2 className="text-primary-500" size={24} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            {translations?.verificationHeader?.header || 'Verification Header'}
          </h1>
          <p className="text-gray-500 mt-1">
            {translations?.verificationHeader?.description ||
              'Verify the data linkage between pilgrims, packages, and flights'}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
